import '../App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import spinnerImg from "../img/independent/spinner_movilizate.gif";
import spinnerCast from "../img/cast_mzate/spinner_movilizate.gif";

const DefaultSpinner = ({ instanceType, independent }) => {

    const spinnerToUse = instanceType === independent ? spinnerImg : spinnerCast;

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
                zIndex: 99999,
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
            }}
        >
            <img
                src={spinnerToUse}
                alt="Cargando..."
                style={{
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block'
                }}
            />
        </div>
    );
};

export default DefaultSpinner;